import DataTable from "react-data-table-component";
import { AddUpdate } from "../../../ApiMethods/ApiMethods"
import React, { useEffect,useState } from "react";
import { customStyles } from "../Utility/Utility";
import { Button, Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";

const AstrologerMobilenoSend = () => {
    const [data,setData]=useState([])
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [loading, setLoading] = useState(false);

    const [selectedChat, setSelectedChat] = useState(null);
    const [showModal, setShowModal] = useState(false);
     const [messages, setMessages] = useState([]);

      const singlechatmessage = useSelector(
         (state) => state.feedBackReducer.GetChatMessagehistory
       );

const getdata=async(fromDate,toDate)=>{
  try{
    setLoading(true);
    const payload = { DateTimeFrom: fromDate || startTime, DateTimeTo: toDate || endTime };
    const res=await AddUpdate("Chat/AstroDetailsendChat", payload)
    const datas=JSON.parse(res?.data?.data || "{}");
    const finaldata=datas?.Table || [];
    setData(finaldata);
  }catch(err){
    console.error(err);
  }finally{
    setLoading(false);
  }
}

useEffect(()=>{
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const formattedToday = `${yyyy}-${mm}-${dd}`;

  setStartTime(formattedToday);
  setEndTime(formattedToday);
  getdata(formattedToday, formattedToday);
},[])

const columns=[
    {name:"S.No",selector:(row,index)=>index+1,sortable:true},
    {name:"Astrologer Name",selector:(row)=>row.DisplayName,sortable:true},
    {name:"Username",selector:(row)=>row.Username,sortable:true},
    {name:"Message",selector:(row)=>row.AllMessages,sortable:true, wrap: true, grow: 2},  
     {
      name: "StartDate",
      selector: (row) => {
        const date = new Date(row.StartTime);
        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false, 
        });
      },
      sortable: true,
      width: "200px",
    },

 {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          View Chat
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item 
              onClick={() => handleEditClick(row)}
              >
                View Chat
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },

]
const handleSearch=async()=>{
  if (!startTime || !endTime) {
    alert("Please select both Start Time and End Time");
    return;
  }

  const formatDate = (dateTime) => {
    if (!dateTime) return null;
    const date = new Date(dateTime);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const formattedStart = formatDate(startTime);
  const formattedEnd = formatDate(endTime);

  await getdata(formattedStart, formattedEnd);
}


 const handleEditClick = (row) => {
  console.log("Selected Row:", row);
    setSelectedChat(row);
    getChatHistory(row.AstroID, row.UserID, row.OrderID);
  
    setShowModal(true);
  };

    useEffect(() => {
      const formattedMessages = singlechatmessage?.map((item) => ({
        sender: item?.IsfromAstro ? "astrologer" : "user",
        text: item?.Message,
      }));
      setMessages(formattedMessages);
    }, [singlechatmessage]);


const getChatHistory = async (astroId, userId, orderId) => {
  try{
    console.log("astroid",astroId,"userId",userId,"orderId",orderId)
    setLoading(true);
    const payload = { AstroID: astroId, UserID: userId, chatOrderId: orderId };
    const res= await AddUpdate("Chat/ReturnChat", payload);
    const datas=JSON.parse(res?.data?.data || "{}");
    const chatMessages=datas?.Table || [];
    const formattedMessages = chatMessages?.map((item) => ({
      sender: item?.IsfromAstro ? "astrologer" : "user",
      text: item?.Message,
    }));
    setMessages(formattedMessages);
  } catch (error) {
    console.error("Error fetching chat history:", error);
  } finally {
    setLoading(false);
  }
};
    return (
        <>
        

<div className="form-group main_card">
  <h2 style={{ color: "#f7931e", fontWeight: 700 }}>
    Astrologer MobileNo Send History
  </h2>

  <div className="row mt-3 align-items-end">
    
    <div className="col-md-3">
      <label className="form-label">Start Time</label>
      <input
        type="date"
        className="form-control"
        value={startTime}
        onChange={(e) => setStartTime(e.target.value)}
      />
    </div>

    <div className="col-md-3">
      <label className="form-label">End Time</label>
      <input
        type="date"
        className="form-control"
        value={endTime}
        onChange={(e) => setEndTime(e.target.value)}
      />
    </div>

    <div className="col-md-auto">
      <button
        className="btn btn-primary"
        onClick={handleSearch}
      >
        Search
      </button>
    </div>

  </div>
</div>


  <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ text: "center" }}>Chat History</Modal.Title>
        </Modal.Header>
      
        <Modal.Body>
          {loading ? (
            <Loader />
          ) : (
            <>
              {selectedChat && (
                <p>
                  <strong style={{ color: "black" }}>
                    Astrologer: {selectedChat.DisplayName}
                  </strong>
                  <br />
                  <strong style={{ color: "black" }}>
                    User: {selectedChat.Username}
                  </strong>
                </p>
              )}
              <hr />
              <div
                className="chat-container"
                style={{ height: "300px", overflowY: "scroll" }}
              >
                {messages?.length > 0 ? (
                  messages?.map((msg, index) => (
                    <div
                      key={index}
                      className={`chat-message ${
                        msg.sender === "astrologer"
                          ? "astro-message"
                          : "user-message"
                      }`}
                    >
                      <strong>{msg?.sender}:</strong> {msg?.text}
                    </div>
                  ))
                ) : (
                  <p>No chat messages available.</p>
                )}
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

 <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '70vh' }}>
                     <DataTable
                         columns={columns}
                         data={data}
                         pagination
                        
                         paginationRowsPerPageOptions={[10, 25, 50, 100]}
                         
                        
                         customStyles={customStyles}
                       
                         persistTableHead
                         responsive
                         fixedHeader
                         fixedHeaderScrollHeight="60vh"
                     />
                 </div>


</>

    )
}
export default AstrologerMobilenoSend